import React from 'react'


type PropsIconCloseModal = {
    handleClickIcon:(posiblesArgs?:any) => void;
    className?:string
}

export default function IconCloseModal(props:PropsIconCloseModal) {
  return (
    <i className= {"fa fal fa-times iconCloseModal " + props.className??""} onClick={()=> props.handleClickIcon()}></i>            
  )
}
     